import { render, staticRenderFns } from "./talk_dinggao.vue?vue&type=template&id=21ac9c93&scoped=true&"
import script from "./talk_dinggao.vue?vue&type=script&lang=js&"
export * from "./talk_dinggao.vue?vue&type=script&lang=js&"
import style0 from "./talk_dinggao.vue?vue&type=style&index=0&id=21ac9c93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac9c93",
  null
  
)

export default component.exports